module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "fm1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('em', [_vm._v("The man of system... is apt to be very wise in his own conceit; and is often so enamored with the supposed beauty of his own ideal plan of government, that he cannot suffer the smallest deviation from any part of it")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Adam Smith")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("“Scientific socialism” would hold especial attraction for intellectuals by promising to replace spontaneous and messy life with a rational order of which they would be the interpreters and mentors")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Richard Pipes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Here’s a good rule of thumb:"), _c('br'), _vm._v("Too clever is dumb")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Ogden Nash"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759e2e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 90
// module chunks = 0